// modules/estrategias/migrante/offline/migranteOffline.js
// Capa fina sobre crudOfflineFactory.js — ahí vive la lógica real
// (evitar pendientes duplicados al reeditar, soportar eliminar offline).
import { crearCrudOffline } from "../../../inicio/offline/crudOfflineFactory";
import { crearPersonaAPI, actualizarPersonaAPI, deletePersona } from "../api/MigranteAPI";

const crud = crearCrudOffline({
  tablaPendientes: "migrante_pendientes",
  apiCrear: crearPersonaAPI,
  apiActualizar: actualizarPersonaAPI,
  apiEliminar: deletePersona,
});

export const guardarOfflineMigrante = (payload, personaId) => crud.guardarOffline(payload, personaId);
export const eliminarOfflineMigrante = (personaId) => crud.eliminarOffline(personaId);
export const contarMigrantePendientes = () => crud.contarPendientes();
export const sincronizarMigrantePendientes = () => crud.sincronizarPendientes();
